var map = {
	"./RND.jpg": 78271,
	"./accounting.jpg": 49283,
	"./consulting.jpg": 88379,
	"./finance.jpg": 43594,
	"./insurance.jpg": 63288,
	"./label_packaging.jpg": 8457,
	"./legal.jpg": 99481,
	"./lifestyle.jpg": 70744,
	"./logistics.jpg": 32426,
	"./marketing.jpg": 93792,
	"./metaverse.jpg": 87068,
	"./networking.jpg": 68304,
	"./real_estate.jpg": 35083,
	"./staff_training.jpg": 11754,
	"./staffing_training.jpg": 38284,
	"./technology.jpg": 13608,
	"./testing_lab.jpg": 32771,
	"./tours.jpg": 90509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6651;